import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";

// Start Bugsnag with the React plugin
Bugsnag.start({
  apiKey: "68c9b390903994a9d1e7ff98a9523cc0",
  plugins: [new BugsnagPluginReact(React)],
});

// Create the ErrorBoundary using the Bugsnag React plugin
const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary();

export default ErrorBoundary;
